// extracted by mini-css-extract-plugin
module.exports = {"cell":"DescriptionCell_cell__2_rjd"};